// retry.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { retryWhen, mergeMap } from 'rxjs/operators';

@Injectable()
export class RetryInterceptor implements HttpInterceptor {

  // Max retry attempts
  private readonly maxRetries = 3;
  // Delay between retries in milliseconds
  private readonly retryDelayMs = 3 * 1000;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      retryWhen(errors =>
        errors.pipe(
          mergeMap((error, retryCount) => {
            // Stop retrying if max retries reached
            if (retryCount >= this.maxRetries) {
              return throwError(() => error);
            }

            // Retry only for network errors or specific HTTP status codes
            if (error instanceof HttpErrorResponse &&
                (error.status === 0 || [400, 500, 502, 503, 504].includes(error.status))) {
              // Wait before retrying
              return timer(this.retryDelayMs);
            }

            // For other errors, don't retry
            return throwError(() => error);
          })
        )
      )
    );
  }
}
